import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { RegulatoryCheckDetailsModel } from '../../Models/Models/Customer/RegulatoryCheckDetailsModel';
import { ValidationStatus } from '../../Core/Web/Validation/ValidationStatus';
import { RegulatoryCheckInfoType } from '../../Constants/Enums/Customer/RegulatoryCheckInfoType';

declare var IS_RUNNING_IN_APP_POOL;

export class RegulatoryCheckDetailsClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(customerId: number): Promise<Array<RegulatoryCheckDetailsModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/RegulatoryCheckDetails/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId }

    return AjaxWrapper.get<Array<RegulatoryCheckDetailsModel>, any>(url, data);
  }
  public post(customerId: number, editType: RegulatoryCheckInfoType, regulatoryCheckDetails: RegulatoryCheckDetailsModel): Promise<ValidationStatus, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/RegulatoryCheckDetails/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId, editType: editType, regulatoryCheckDetails: regulatoryCheckDetails }

    return AjaxWrapper.post<ValidationStatus, any>(url, data);
  }
  public put(customerId: number, editType: RegulatoryCheckInfoType, regulatoryCheckDetails: Array<RegulatoryCheckDetailsModel>): Promise<ValidationStatus, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Customer/RegulatoryCheckDetails/Put';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { customerId: customerId, editType: editType, regulatoryCheckDetails: regulatoryCheckDetails }

    return AjaxWrapper.put<ValidationStatus, any>(url, data);
  }
}

